import { config} from '@/common'

function Main() {
    const year_start = 2022
    const year = (new Date()).getFullYear()
    return (
        <div className="copyright">
            技术支持
            <a href="https://mos01.com/" target='_blank'>魔思科技</a>
            © {(year === year_start) || `${year_start} - `}{year} {config.app.name}
            <a href="https://beian.miit.gov.cn/#/Integrated/index" target='_blank'>鄂ICP备2022013758号-1</a>
        </div>
    )
}
export default Main